var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarForth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.825 23.8192C5.17592 23.1705 5.17535 22.1186 5.82372 21.4692L12.2832 14.9996L5.82372 8.53003C5.17535 7.88066 5.17592 6.8287 5.825 6.18003C6.474 5.53144 7.52581 5.53144 8.17481 6.18003L16.2921 14.2923C16.683 14.6829 16.683 15.3164 16.2921 15.7069L8.17481 23.8192C7.52581 24.4678 6.474 24.4678 5.825 23.8192Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1751 23.8192C13.526 23.1705 13.5254 22.1186 14.1738 21.4692L20.6333 14.9996L14.1738 8.53003C13.5254 7.88066 13.526 6.8287 14.1751 6.18003C14.8241 5.53144 15.8759 5.53144 16.5249 6.18003L24.6422 14.2923C25.033 14.6829 25.033 15.3164 24.6422 15.7069L16.5249 23.8192C15.8759 24.4678 14.8241 24.4678 14.1751 23.8192Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarForth);
export default __webpack_public_path__ + "static/media/calendar_forth.8bdcbd5855985847b6e0202de053f211.svg";
export { ForwardRef as ReactComponent };